import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertCircle, LogOut, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Con sesión pero SIN rol: la consulta de `user_roles` (o la del perfil) falló
 * al abrir la app —sin cobertura, un 500— o esta persona no tiene rol en su
 * empresa.
 *
 * Auditoría V1-OBS (26-09-2026): el enrutador caía entonces en la rama del
 * ADMIN y un perito veía el menú y el panel de admin (Equipo, Ajustes, Costes).
 * Los datos seguían protegidos por la base, pero la pantalla mentía. Ahora
 * nadie entra en ningún portal sin saber quién es: esta pantalla y «Reintentar».
 */
export function AccountLoadError() {
  const { t } = useTranslation();
  const { refreshProfile, signOut } = useAuth();
  const [retrying, setRetrying] = useState(false);

  const retry = async () => {
    setRetrying(true);
    try {
      await refreshProfile();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div
      role="alert"
      data-testid="account-load-error"
      className="min-h-[100dvh] flex flex-col items-center justify-center gap-4 px-6 text-center"
      style={{ background: "var(--bg-page)" }}
    >
      <AlertCircle className="h-12 w-12 text-destructive" />
      <div className="max-w-sm space-y-1">
        <h1 className="text-lg font-bold text-foreground">{t("accountLoadError.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("accountLoadError.body")}</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button onClick={retry} disabled={retrying} className="gap-2">
          <RefreshCw className={retrying ? "h-4 w-4 animate-spin" : "h-4 w-4"} />
          {t("accountLoadError.retry")}
        </Button>
        <Button variant="ghost" onClick={() => signOut()} className="gap-2">
          <LogOut className="h-4 w-4" />
          {t("accountLoadError.signOut")}
        </Button>
      </div>
    </div>
  );
}
